import { type AsyncState, Status } from '@essent/common';
import type { PostThirdpartyV1Response } from '@integration/api-client/feh';
import { createReducer, on } from '@ngrx/store';
import type { ScLinkField } from '@core/jss-models';
import { FehApiActions } from '@feh/shared-api';

import {
  setRedirectUrl,
  submitRabobankFormSuccess,
} from './rabobank-form.actions';

export const sustainabilityRabobankId = 'rabobankForm';

export interface RabobankFormState {
  submitState: AsyncState<PostThirdpartyV1Response>;
  redirectUrl: ScLinkField | null;
}

export const rabobankInitialState: RabobankFormState = {
  submitState: { status: Status.IDLE },
  redirectUrl: null,
};

/**
 * Only update when actionId belongs to rabobank form
 */
function updateOrIgnore<T>(actionId: unknown, oldState: T, newState: T): T {
  return actionId === sustainabilityRabobankId ? newState : oldState;
}

const apiActions = FehApiActions.postThirdpartyV1;

export const rabobankFormReducer = createReducer(
  rabobankInitialState,
  on(apiActions.requestAction, (state, { actionId }) =>
    updateOrIgnore(actionId, state, {
      ...state,
      submitState: { status: Status.PENDING },
    })
  ),
  on(apiActions.successAction, (state, { actionId, payload }) =>
    updateOrIgnore(actionId, state, {
      ...state,
      submitState: { status: Status.SUCCESS, data: payload },
    })
  ),
  on(apiActions.errorAction, (state, { actionId, payload }) =>
    updateOrIgnore(actionId, state, {
      ...state,
      submitState: { status: Status.ERROR, error: payload },
    })
  ),
  on(setRedirectUrl, (state, { redirectUrl }) => {
    return {
      ...state,
      redirectUrl,
    };
  }),
  on(submitRabobankFormSuccess, (state) => {
    return {
      ...state,
      submitState: { status: Status.IDLE },
    };
  })
);
